// extracted by mini-css-extract-plugin
module.exports = {"button":"CookieConsentDeclineButton_button__Vh9xM","text":"CookieConsentDeclineButton_text__TSENg"};